import { connect } from 'react-redux';
import Purchase from '../lib/purchase';
import Payment from '../lib/payment';
import {
  getOrganizerMembership,
  getCurrentUserMembership,
} from '../selectors/purchase-selector';

import SmartDeadlinePopover from
  '../components/smart-deadline-popover.js';

const mapStateToProps = (state) => {
  const purchase = state.purchases.byId[state.purchases.current];
  const isActive = Purchase.isActive(purchase.status);
  const isExpired = Purchase.isDateExpired(purchase.group.commitDeadline);
  const organizerMembership = getOrganizerMembership(state);
  const currentUserMembership = getCurrentUserMembership(state);
  const isCompleted = Purchase.isCompleted(purchase);
  const { nextPaymentDueDeadline } = purchase;

  const paymentsInCaputredOrLaterState = purchase.payments.filter(({ status }) => {
    return Payment.isCaptured(status) || Payment.isPaid(status);
  });

  const haveActivePayments = purchase.payments.filter(({ status }) => {
    return Payment.isActive(status);
  }).length > 0;

  const isOrganizer = organizerMembership === currentUserMembership;

  return {
    isActive,
    isExpired,
    isOrganizer,
    haveActivePayments,
    nextPaymentDueDeadline,
    isCompleted,
    paymentsInCaputredOrLaterState,
  }
}

export default connect(mapStateToProps)(SmartDeadlinePopover);



// WEBPACK FOOTER //
// ./src/containers/smart-deadline-popover.container.js